import axios from 'axios';
import {
  GET_USER_AGREEMENT_REQUEST,
  GET_USER_AGREEMENT_SUCCESS,
  GET_USER_AGREEMENT_FAILURE
} from 'Store/constants';
import errorMessage from 'Store/actions/errorMessage';

export const getUserAgreement = () => async dispatch => {
  try {
    dispatch({
      type: GET_USER_AGREEMENT_REQUEST
    });
    const res = await axios.get('/cms/userAgreement/latestNewUserAgreement/');

    dispatch({
      type: GET_USER_AGREEMENT_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    dispatch({
      type: GET_USER_AGREEMENT_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};
